import type { LosiGameDef, LosiGameId } from './types'

/** Titles match the sketch / arcade plain names — no “Eye …” branding. */
export const LOSI_GAMES: LosiGameDef[] = [
  {
    id: 'ping-pong',
    title: 'Ping Pong',
    blurb: 'Two paddles. Adaptive opponent. Miss and the run ends.',
    eyeRole: 'paddles'
  },
  {
    id: 'eye-break',
    title: 'Breakout',
    blurb: 'Catch drops — multiball, sticky, wide, laser. Waves keep stacking.',
    eyeRole: 'bricks'
  },
  {
    id: 'eye-snake',
    title: 'Snake',
    blurb: 'Grow the chain. Eat the dots. Don’t hit the wall.',
    eyeRole: 'body'
  },
  {
    id: 'eye-flap',
    title: 'Flap',
    blurb: 'Tap to rise. Thread the gaps in the pipes.',
    eyeRole: 'ship'
  },
  {
    id: 'eye-match',
    title: 'Match',
    blurb: 'Watch the sequence. Tap it back. Classic memory.',
    eyeRole: 'pads'
  },
  {
    id: 'space-shooter',
    title: 'Space',
    blurb: 'Clear each quota — levels keep stacking.',
    eyeRole: 'enemies + ship'
  },
  {
    id: 'asteroids',
    title: 'Asteroids',
    blurb: 'Thrust, wrap, split the rocks. Fields keep coming.',
    eyeRole: 'ship + rocks'
  },
  {
    id: 'pinball',
    title: 'Pinball',
    blurb: 'Star table. Flippers. Drain ends the run.',
    eyeRole: 'flippers'
  },
  {
    id: 'vibecode',
    title: 'Vibecode',
    blurb: 'Describe a game. Agents draft levels. Save to your library.',
    eyeRole: 'designer'
  }
]

export function gameById(id: LosiGameId): LosiGameDef | undefined {
  return LOSI_GAMES.find((g) => g.id === id)
}
